<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toctitle"><a id="page_3">Contents</a></h1><a id="page_3">
</a><h2 class="toc"><a id="page_3"></a><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01">Knitting know-how</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">Polar Bear</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Chicks</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Koala Bear</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Fox</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Teddy Bear</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Guinea Pig</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Mouse</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Baby Penguin</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Mr &amp; Mrs Hamster</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Bunny</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Otter</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">Owl</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">Hedgehog</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter15" title="Link target outside of Sample">Squirrel</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter16" title="Link target outside of Sample">Seal Pup</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter17" title="Link target outside of Sample">Robin</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter18" title="Link target outside of Sample">Raccoon</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Chapter19" title="Link target outside of Sample">Fat Cat</span></h2>
<h2 class="toc"><span href="#/xhtml/26_Chapter20" title="Link target outside of Sample">Puppy</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Chapter21" title="Link target outside of Sample">Duck &amp; Ducklings</span></h2>
<div class="img_container">
<img alt="image" src="images/pg5-1.jpg"/>
<img alt="image" src="images/pg5-2.jpg"/>
<img alt="image" src="images/pg5-3.jpg"/>
<img alt="image" src="images/pg5-5.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?755813bc